/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Manageroles_Continue1Inputs */

const en_settings_collaborators_manageroles_continue1 = /** @type {(inputs: Settings_Collaborators_Manageroles_Continue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with selection`)
};

/**
* | output |
* | --- |
* | "Continue with selection" |
*
* @param {Settings_Collaborators_Manageroles_Continue1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_manageroles_continue1 = /** @type {((inputs?: Settings_Collaborators_Manageroles_Continue1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Manageroles_Continue1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_manageroles_continue1(inputs)
});
export { settings_collaborators_manageroles_continue1 as "settings_collaborators_manageRoles_continue" }